import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import messages from "components/messagesDescription";
import { fetchCategoryProducts, fetchCategories } from "actions/marketplaceActions";
import ProductItem from "./ProductItem";
import { Button, Loader } from "cxa-components";
import { injectIntl } from "react-intl";
import Breadcrumb from "./Breadcrumb";
import SearchBar from "./SearchBar";
import { withRouter } from "react-router-dom";

const CategoryPage = ({
  categoryId,
  products = [],
  categories = [],
  fetchCategoryProducts,
  fetchCategories,
  isFetching,
  intl,
  ...props
}) => {
  useEffect(() => {
    fetchCategoryProducts(categoryId);
    fetchCategories();
  }, [categoryId]);

  const loadMoreProducts = () => {
    fetchCategoryProducts(categoryId, products.params);
  };

  const selectedCategory = categories.find(x => x.tagId == categoryId);

  return (
    <div>
      <SearchBar {...props} />
      {selectedCategory && (
        <Breadcrumb
          categoryTags={[
            {
              categoryId: selectedCategory.tagId,
              categoryName: selectedCategory.tagName,
            },
          ]}
          intl={intl}
        />
      )}
      <div className="product-list-container">
        {selectedCategory && (
          <strong>
            <u style={{ marginLeft: "10px" }}>
              {intl.formatMessage({
                id: selectedCategory.tagName,
                defaultMessage: selectedCategory.tagName,
              })}
              :
            </u>
          </strong>
        )}
        {isFetching && <Loader />}
        <div className="card-container">
          {products.data.map(item => {
            return <ProductItem key={item.productId} product={item} />;
          })}
        </div>
        {products.showMore && !isFetching && (
          <Button onClick={loadMoreProducts} primary className="load-more-btn">
            {intl.formatMessage(messages.marketplace.seeMoreLabel)}
          </Button>
        )}
      </div>
    </div>
  );
};

CategoryPage.propTypes = {
  categoryId: PropTypes.string,
  providerId: PropTypes.string,
  products: PropTypes.array,
  isFetching: PropTypes.bool,
  categories: PropTypes.array,
  fetchCategoryProducts: PropTypes.func.isRequired,
  fetchCategories: PropTypes.func.isRequired,
  intl: PropTypes.object,
};

const mapStateToProps = (
  { marketplace: { categoryProducts, categories, isFetching } },
  ownProps
) => ({
  products: categoryProducts,
  categories,
  categoryId: ownProps.match.params.categoryId,
  isFetching,
});

const mapDispatchToProps = {
  fetchCategoryProducts,
  fetchCategories,
};

export default withRouter(injectIntl(connect(mapStateToProps, mapDispatchToProps)(CategoryPage)));



// WEBPACK FOOTER //
// ./components/marketplace/CategoryPage.jsx